export default "__VITE_ASSET__DH$Y6WCZ__"